import request from '../../utils/request'
import request2 from '../../utils/requestLoginUserInfo'
import {downloadFileRequest} from '../../utils/downloadFile'



/* 登录 */
// 管理后台临时登录接口
export function tempLogin(data) {
  return request(`/tempLogin`, 'post', data)
}
// 获取用户信息接口
export function tryLoginUserInfo(data) {
  return request2(`tryLoginUserInfo`, 'post', data)
}
// 登陆退出
export function logout(data, head) {
  return request2(`logout`, 'get', data, false, head)
}

// 登陆
export function login(data, head) {
  return request2(`login`, 'post', data, false, head)
}

// 查询首页-顶部栏基本信息
export function findTopBarApi(data) {
  return request(`/home/findTopBar`, 'get', data)
}
// 查询前端页面导航信息
export function findNavApi(data) {
  return request(`/nav/findNav`, 'get', data)
}
// 查询前端页面导航banner信息
export function findNavBannerApi(data) {
  return request(`/nav/${data}/findNavBanner`, 'get', data)
}

// 查询首页-顶部栏悬浮按钮信息
export function findHoverApi(data) {
  return request(`/home/findHover`, 'get', data)
}
// 查询底部栏信息
export function findBottomBarApi(data) {
  return request(`/home/findBottomBar`, 'get', data)
}
// 查询首页-顶部办事栏
export function findTopBannerApi(data) {
  return request(`/home/findTopBanner`, 'post', data)
}
// 查询首页-办事服务列表
export function findServiceApi(data) {
  return request(`/home/findService`, 'post', data)
}
// 查询首页-特色专栏列表
export function findFeatureColumnByListApi(data) {
  return request(`/home/findFeatureColumnByList`, 'post', data)
}
// 查询首页-开启的模块信息
export function findHomeModuleApi(data) {
  return request(`/home/findHomeModule`, 'get', data)
}
// 查询首页-快捷通道列表
export function findChannelApi(data) {
  return request(`/home/${data}/findChannel`, 'post', data)
}
// 查询首页-通知公告列表
export function findNoticeApi(data) {
  return request(`/home/findNotice`, 'post', data)
}
// 查询首页-服务统计
export function findServiceSummaryApi(data) {
  return request(`/home/findServiceSummary`, 'get', data)
}

/* 搜索页面 */
// 统计搜索模块
export function summarySearchModuleApi(data) {
  return request(`/home/summarySearchModule`, 'post', data)
}
// 查询事项管理
export function findServiceManageByKeywordApi(data) {
  return request(`/home/findServiceManageByKeyword`, 'post', data)
}
// 查询查询主题专区
export function findHomeThemeByKeywordApi(data) {
  return request(`/home/findThemeByKeyword`, 'post', data)
}
// 查询通知公告
export function findHomeNoticeByKeywordApi(data) {
  return request(`/home/findNoticeByKeyword`, 'post', data)
}



/* 主题专区 */
// 查询主题专区列表
export function findThemeByKeywordApi(data) {
  return request(`/theme/findThemeByKeyword`, 'post', data)
}
// 通过主题id查询主题基本信息
export function findThemeByIdApi(data) {
  return request(`/theme/${data}/findThemeById`, 'post', data)
}
// 查询某个主题下的服务分类设置
export function findThemeServiceByThemeIdApi(data) {
  return request(`/theme/${data}/findThemeServiceByThemeId`, 'post', data)
}
// 查询某个主题下的服务分类设置
export function findThemeIssuesByThemeServiceIdApi(data) {
  return request(`/theme/${data}/findThemeIssuesByThemeServiceId`, 'post', data)
} 
// 查询某个主题专区下的常见问题
export function findThemeAqByThemeIdApi(data) {
  return request(`/theme/${data}/findThemeAqByThemeId`, 'post', data)
}


/* 事项管理 */
// 查询事项管理
export function findServiceManageApi(data) {
  return request(`/serviceManage/findServiceManage`, 'post', data)
}
// 查询服务对象
export function findTargetsApi(data) {
  return request(`/serviceManage/findTargets`, 'get', data)
}
// 查询可用的部门管理
export function findDepartmentApi(data) {
  return request(`/serviceManage/findDepartmentByAvailable`, 'get', data)
}
// 查询可用的事项分类
export function findServiceClassifyApi(data) {
  return request(`/serviceManage/findServiceClassifyByAvailable`, 'get', data)
}
// 查询指定事项管理详细信息
export function findServiceManageDetailByIdApi(data) {
  return request(`/serviceManage/${data}/findServiceManageDetailById`, 'post', data)
}
// 查询某个制度文件的详细信息
export function findInstitutionFileDetailApi(data) {
  return request(`/serviceManage/findInstitutionFileDetail`, 'post', data)
}
// 对制度文件中的附件进行下载
export function downloadInstitutionFileApi(data) {
  // return request(`/serviceManage/downloadInstitutionFile`, 'post', data)
  return downloadFileRequest(`/serviceManage/downloadInstitutionFile`, 'post', data)
}

/* 三张清单 */
// 通过部门id查询部门信息
export function findDeptByIdApi(data) {
  return request(`/inventory/${data}/findDeptById`, 'post', data)
}
// 查询责任清单信息
export function findLiabilitiesApi(data) {
  return request(`/inventory/findLiabilities`, 'post', data)
}
// 查询服务清单信息
export function findListServiceApi(data) {
  return request(`/inventory/findListService`, 'post', data)
}
// 查询审批清单信息
export function findApprovalApi(data) {
  return request(`/inventory/findApproval`, 'post', data)
}
// 通过部门id统计服务清单的线上线下数量
export function countWayNumberByListServiceApi(data) {
  return request(`/inventory/countWayNumberByListService/${data}`, 'post', data)
}

/* 通知公告 */
// 通知公告-查询通知公告列表
export function findNoticeByKeywordApi(data) {
  return request(`/notice/findNoticeByKeyword`, 'post', data)
}
// 查询通知公告详情
export function findNoticeByIdApi(data) {
  return request(`/notice/${data}/findNoticeById`, 'post', data)
}
// 查询通知公告banner
export function findNoticeBannerApi(data) {
  return request(`/notice/findNoticeBanner`, 'get', data)
}




